import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Menu, Icon } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

const SidebarView = ({ isLane, returnUrl }) => {
  return (
    <Menu text vertical className='app-side-nav'>
      {isLane && (
        <Fragment>
          <Menu.Item as={NavLink} to={'/lanes/active'}>
            <Icon name='chevron left' />
            Return to Lanes
          </Menu.Item>
          <Menu.Item>
            <hr style={{ margin: '.5em 2em' }} />
          </Menu.Item>
        </Fragment>
      )}
      <Menu.Item
        as={NavLink}
        to={returnUrl}
        data-automation-id={'return-to-marketplace'}
      >
        <Icon name='chevron left' />
        Return to Home Screen
      </Menu.Item>
    </Menu>
  )
}

SidebarView.propTypes = {
  isLane: PropTypes.bool,
  returnUrl: PropTypes.string.isRequired,
}

export default SidebarView
